import React from 'react'
import { CFooter } from '@coreui/react'

const TheFooter = () => {
  return (
    <CFooter fixed={false}>
      <div className="mfs-auto">
        UCCS 1.0.0 <small> powered by Gematica</small>
      </div>
    </CFooter >
  )
}

export default React.memo(TheFooter)
